var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderNotes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23955",
    "data-name": "Group 23955",
    transform: "translate(-1340 -193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6954",
    "data-name": "Rectangle 6954",
    transform: "translate(1340 193)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 23,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 17.5,
    height: 21.5,
    rx: 2.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_525",
    "data-name": "Line 525",
    x2: 10,
    transform: "translate(1344.5 198.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_528",
    "data-name": "Line 528",
    x2: 10,
    transform: "translate(1344.5 204.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_530",
    "data-name": "Line 530",
    x2: 10,
    transform: "translate(1344.5 210.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_526",
    "data-name": "Line 526",
    x2: 5,
    transform: "translate(1344.5 201.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_527",
    "data-name": "Line 527",
    x2: 5,
    transform: "translate(1344.5 207.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderNotes);
export default __webpack_public_path__ + "static/media/order_notes.bf2178b645d86ccd72df0cef6a3b7992.svg";
export { ForwardRef as ReactComponent };